import script from "./StudentAttendanceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentAttendanceDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentAttendanceDialog.vue?vue&type=style&index=0&id=39f90619&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f90619"]])

export default __exports__